<template>
  <div class="roof-rack-block">
    <div v-if="loading" class="preselect__spinner-container">
      <span class="preselect__spinner" aria-hidden="true" />
    </div>
    <div v-else-if="car" class="roof-rack__container">
      <p class="roof-rack-block__car-name">{{ car.brand }} {{ car.model }}</p>
      <p class="roof-rack-block__note">
        {{ loadedText }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import axios from 'axios';
import { onMounted, ref } from 'vue';

import { generateUrl } from '@shop/utils/Routing';
import { useTranslation } from '@shop/utils/Translation';

import type { RoofRackCar } from './RoofRackBlock.types';

useTranslation('roofrack_tool');

const carId = ref<number | null>(null);
const car = ref<RoofRackCar | null>(null);
const loading = ref(false);

const loadedText = 'Car loaded. Full product selection is available on the category page.';

onMounted(() => {
  const params = new URLSearchParams(window.location.search);
  const rawCarId = params.get('car_id');
  carId.value = rawCarId ? parseInt(rawCarId, 10) : null;

  if (!carId.value) {
    return;
  }

  loading.value = true;
  axios
    .get<RoofRackCar>(generateUrl('category_tool_car_detail', { car: carId.value }))
    .then(response => {
      car.value = response.data ?? null;
    })
    .finally(() => {
      loading.value = false;
    });
});
</script>
